import { HttpClient } from '@zeta-core';
import { APIResponse } from '@zeta-types';

import { COMPLIANCE_SERVICE } from '../services-path';

export const ComplianceService = () => {
  return {
    // compliance
    consumerDuty: (payload: { file: File, session_id: String, topic: String, advisor_id: string }): APIResponse<string> => HttpClient.upload(`${COMPLIANCE_SERVICE}/compliance/consumer_duty`, payload),
    fetchReviews: (payload: { advisorId: String }): APIResponse<string> => HttpClient.get(`${COMPLIANCE_SERVICE}/compliance-results?advisorId=${payload.advisorId}`),
    fetchReview: (payload: { reviewId: String}): APIResponse<string> => HttpClient.get(`${COMPLIANCE_SERVICE}/compliance-results/${payload.reviewId}`),
    deleteReview: (payload: { reviewId: String}): APIResponse<string> => HttpClient.delete(`${COMPLIANCE_SERVICE}/compliance-results/${payload.reviewId}`),
  };
};
